import styled from "styled-components";

export const RolesAndPermissionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
`;

